import { Passenger } from "../passenger.model";
import moment from 'moment';

export class RequestContactability {
    fecha: string;
    hora: string;
    flujo: string;
    paso: string;
    pnr: string;
    ticket: number;
    nombre: string;
    tipoPasajero: string;
    avisoPrivacidad: number;
    fechaNacimiento: string;
    paisResidencia: string;
    telefono: number;
    tipoTelefono: string;
    optinWhatsapp: boolean;
    correo: string;
    pnrCreateDate: string;
    fechaHoraConsentimiento: string;
    PNRPassengerSEQID: string;

    constructor(passenger: Passenger, pnr: string) {
        this.fecha = moment().format('YYYY-MM-DD'); 
        this.hora = moment().format('HH:ss'); 
        this.flujo = 'Kiosco';
        this.paso = 'CKI';
        this.pnr = pnr; 
        this.ticket = passenger.ticketInfo.eticket,
        this.nombre = passenger.displayName, 
        this.tipoPasajero = passenger.paxType,
        this.avisoPrivacidad = 1,
        this.fechaNacimiento = passenger.dateOfBirth,
        this.paisResidencia = passenger.passengerInfo.countryResidence || 'MEX', 
        this.telefono = passenger.phones[0]?.number || '',
        this.tipoTelefono = 'MOVIL';
        this.optinWhatsapp = false;
        this.correo = passenger.passengerInfo.emails[0]|| ''
        this.pnrCreateDate = '';
        this.PNRPassengerSEQID = '';
        this.fechaHoraConsentimiento =  moment().format('YYYY-MM-DD HH:ss:mm');
    }
}
